var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2641_33247)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.5155 18.4629H13.5781V22.9622H14.5155V18.4629Z",
    fill: "#131542"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5938 22.931V18.4941H16.4686V22.931H15.5938Z",
    fill: "#131542",
    stroke: "#131542",
    strokeWidth: 0.0625
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.4842 18.4629H17.5469V22.9622H18.4842V18.4629Z",
    fill: "#131542"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5155 25.9619H13.5781V30.4612H14.5155V25.9619Z",
    fill: "#131542"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4999 25.9619H15.5625V30.4612H16.4999V25.9619Z",
    fill: "#131542"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.4842 25.9619H17.5469V30.4612H18.4842V25.9619Z",
    fill: "#131542"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5074 23.9932H13.5469V24.9305H18.5074V23.9932Z",
    fill: "#131542"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.4686 25.9619H21.5312V30.4612H22.4686V25.9619Z",
    fill: "#131542"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4686 25.9619H23.5312V30.4612H24.4686V25.9619Z",
    fill: "#131542"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4686 25.9619H9.53125V30.4612H10.4686V25.9619Z",
    fill: "#131542"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.46863 25.9619H7.53125V30.4612H8.46863V25.9619Z",
    fill: "#131542"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9995 8.49609C14.0871 8.49609 12.5312 10.0519 12.5312 11.9643C12.5312 13.8768 14.0871 15.4326 15.9995 15.4326C17.9119 15.4326 19.4678 13.8768 19.4678 11.9643C19.4678 10.0519 17.9119 8.49609 15.9995 8.49609ZM15.9995 14.4952C14.6039 14.4952 13.4686 13.3599 13.4686 11.9643C13.4686 10.5688 14.6039 9.43347 15.9995 9.43347C17.3951 9.43347 18.5304 10.5688 18.5304 11.9643C18.5304 13.3599 17.3951 14.4952 15.9995 14.4952Z",
    fill: "#131542"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5311 10.4648V11.4959H14.5V12.4333H16.4684V10.4648H15.5311Z",
    fill: "#131542"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4686 2.46582H15.5312V3.4657H16.4686V2.46582Z",
    fill: "#131542"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9999 7.99609H19V8.93347H19.9999V7.99609Z",
    fill: "#131542"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9999 7.99609H12V8.93347H12.9999V7.99609Z",
    fill: "#131542"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9999 14.9941H19V15.9315H19.9999V14.9941Z",
    fill: "#131542"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9999 14.9941H12V15.9315H12.9999V14.9941Z",
    fill: "#131542"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.9951 31.4924L28.4669 31.5108V22.8518L27.788 21.4939H27.4671V19.9629H26.5297V21.4939H26.2087L25.5299 22.8518V23.9935H23.4989V24.9309H25.5299V31.4924H20.4681V24.9309H22.4991V23.9935H20.4681V17.4321H20.6934L21.4679 16.6576V7.2707L20.6934 6.4962H19.9681V5.27095L19.1936 4.49645H18.4684V2.8092L16.7342 0.49707H15.2657L13.5316 2.8092V4.49645H12.8064L12.0319 5.27095V6.49613H11.3066L10.5321 7.27063V9.46463H11.4695V7.65888L11.6948 7.43357H12.0319H19.9681H20.3052L20.5305 7.65888V16.2693L20.3052 16.4946H11.6948L11.4695 16.2693V10.4646H10.5321V16.6575L11.3066 17.432H11.5319V23.9935H6.47019V22.8518L5.79125 21.4939H5.47038V19.9629H4.53306V21.4939H4.21219L3.53325 22.8518V31.4948L0 31.5132L0.004875 32.4506L32 32.4298L31.9951 31.4924ZM14.469 3.12176L15.7344 1.43451H16.2656L17.5311 3.12176V4.49657H14.469V3.12176ZM19.0308 6.4962H12.9692V5.6592L13.1946 5.43388H13.5316H18.4684H18.8054L19.0308 5.6592V6.4962H19.0308ZM4.47044 23.0731L4.79138 22.4313H5.21187L5.53275 23.0731V23.9935H4.47044V23.0731ZM5.53288 31.4924H4.4705V24.9309H5.53281L5.53288 31.4924ZM11.5319 31.4924H6.47019V24.9309H11.5319V31.4924ZM19.5307 23.9936V31.4924H12.4693V23.9936V17.4321H19.5308V23.9936H19.5307ZM27.5295 31.4924H26.4672V24.9309H27.5295V31.4924ZM27.5296 23.9935H26.4673V23.0731H26.4672L26.7881 22.4313H27.2086L27.5296 23.0731V23.9935Z",
    fill: "#131542"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2641_33247"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.473633)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUk);
export default __webpack_public_path__ + "static/media/UK.e9c0c27a22ff7a34175421ae97b5c264.svg";
export { ForwardRef as ReactComponent };